import type { GenItem } from '../types/timeline'

export function isGenItemInLibrary(genItemIds: Set<string> | undefined | null, genItemId: string): boolean {
  return !!genItemIds?.has(genItemId)
}

export function countRoundItemsInLibrary(items: GenItem[], genItemIds: Set<string> | undefined | null): {
  saved: number
  total: number
} {
  const total = items.length
  if (!total || !genItemIds) return { saved: 0, total }
  let saved = 0
  for (const it of items) {
    if (genItemIds.has(it.id)) saved += 1
  }
  return { saved, total }
}
